import React from 'react';
import PropTypes from 'prop-types';

import ClearIcon from '@mui/icons-material/Clear';

import { cancelledStatuses, canEditSlot } from '../utils/calendarUtils';

import pills from '../../../commonStyles/pillSelections.module.css';

const ParticipantSelectedPills = ({
    participants,
    statuses,
    areAnySlotsResolved,
    isInPast,
    onRemove,
    roles
}) => (
    <div className={pills.selectionList} data-testid={'selected-participant-pills'}>
        {participants.length
            ? participants.map((el) => (
                  <span
                      key={el.id}
                      className={`${pills.pill} ${cancelledStatuses.includes(statuses[el.id]) ? `${pills.pillCancelled}` : ''}`}
                      data-testid={'pt_pill'}>
                      {(statuses[el.id] === 'Not known' || !statuses[el.id]) &&
                          !el.hidden &&
                          canEditSlot(
                              areAnySlotsResolved,
                              'removeParticipant',
                              roles,
                              isInPast
                          ) && (
                              <span
                                  className={pills.clearIcon}
                                  onClick={() => onRemove(el.id)}
                                  data-testid={`pill_remove_button_${el.id}`}>
                                  <ClearIcon />
                              </span>
                          )}
                      <span>
                          {el.firstName ?? el.hidden} {el.lastName}
                      </span>
                  </span>
              ))
            : 'No participants selected'}
    </div>
);

ParticipantSelectedPills.propTypes = {
    participants: PropTypes.arrayOf(PropTypes.object),
    statuses: PropTypes.object,
    areAnySlotsResolved: PropTypes.bool,
    isInPast: PropTypes.bool,
    onRemove: PropTypes.func,
    roles: PropTypes.arrayOf(PropTypes.string)
};

export default ParticipantSelectedPills;
